import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {
  FieldType,
  FormModel,
  FormType,
  ReponseState,
  ResponseStateInstruction
} from '../../common/components/form/models';
import {FormulaireService} from '../../common/services/formulaire/formulaire.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {DatePipe} from '@angular/common';
import {ResponsesService} from '../../common/services/responses/responses.service';
import {FileSaverService, Individu, PubSubService, TypeIndividu} from '@Common/core/services';
import {ResponseForm} from '../../common/components/form/models/responsedemat.model';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {NewlinePipe, SafeHtmlPipe, SlugifyPipe} from '@Common/widgets/pipes';
import {SubSink} from '@Common/core/utils/subsink';
import {MatDialog} from '@angular/material/dialog';
import {FilterFieldCustomEnabled} from '../../common/services/responses/filter-field-custom-enabled.model';
import {FilterFieldResponseEnabled} from '../../common/services/responses/filter-field-response-enabled.model';
import {ResponseStateGestModel} from '../../common/components/form/response-states/response-state-gest-model';
import {InstructionService} from '../../common/services/instructions/instruction.service';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {finalize} from 'rxjs/operators';
import {HelperService} from '../../common/services/helper.service';
import {Entite} from '@Services/entite/entite.model';
import {TypeDemandes} from 'app/demat/gestion/demandes/formulaires-demandes-liste/type-demandes.enum';

@Component({
  selector: 'app-reponses',
  templateUrl: './reponses.component.html',
  styleUrls: ['./reponses.component.scss']
})
export class ReponsesComponent implements OnInit, OnDestroy {
  @Input() form: FormModel;
  @Input() onlyArchived = false;
  @Input() filterState = null;
  @Output() onSelectResponse: EventEmitter<ResponseForm> = new EventEmitter<ResponseForm>();
  dsResponses: MatDataSourceGeneric<ResponseForm> = new MatDataSourceGeneric<ResponseForm>();
  extraParams: Map<string, string> = new Map<string, string>();
  extraDict: Map<string, string[]> = new Map<string, string[]>();
  force = 0;
  exporting = false;
  ONGLET_ARCHIVED = 'Liste des demandes archivées';
  subSink = new SubSink();
  backFilterStates: ResponseStateInstruction[] = null;
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  columns: ColumnDataTable[] = [
    {
      columnDef: 'reference', header: 'Reference',
      display: (row: ResponseForm) => row?.reference,
      sortField: 'reference', sort: true, flex: 9
    },
    {
      columnDef: 'user', header: 'Envoyé par',
      display: (row: ResponseForm) => this.demandeurInfo(row.user_obj),
      tooltip: (row: ResponseForm) => this.demandeurInfo(row.user_obj),
      sort: true,
      flex: 30
    },
    /*{
      columnDef: 'type', header: 'Type',
      display: (row: ResponseForm) => row.user_obj.type === TypeIndividu.intern ? 'Interne' : 'Externe',
      sort: true,
      flex: 30
    },*/
    {
      columnDef: 'state',
      header: 'Statut instruction',
      display: (row: ResponseForm) => this.getStateInstructions(row, this.form),
      sortField: 'last_instruction__state',
      sort: true,
    },
    {
      columnDef: 'dt_created', header: 'Envoyé le', display: (row: ResponseForm) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${row.dt_created}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (row) => row.dt_created,
      sort: true
    },
    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (row: ResponseForm) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${row.dt_updated}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (row) => row.dt_updated,
      sort: true
    },
  ];

  actions: ActionDataTable[] = [
    {
      label: 'archived', tooltip: 'Archiver cette demande', icon: 'archive',
      hidden: (row: ResponseForm) => this._hiddenArchiveAction(row),
      click: (row: ResponseForm) => this._openArchiveConfirmation(row),
      iconcolor: 'warn',
    },
    {
      label: 'unarchived', tooltip: 'Désarchiver cette demande', icon: 'unarchive',
      hidden: (row: ResponseForm) => this._hiddenUnarchiveAction(row),
      click: (row: ResponseForm) => this._openUnarchiveConfirmation(row),
      iconcolor: 'primary',
    },
    {
      label: 'reponse_onglet', tooltip: 'Voir réponse dans un nouvel onglet', icon: 'tab',
      click: (row: ResponseForm) => this.tabResponse(row),
      iconcolor: 'accent',
    },
    {
      label: 'reponse_modal', tooltip: 'Voir réponse en modale', icon: 'outbound',
      click: (row: ResponseForm) => this.modaleResponse(row),
      iconcolor: 'accent',
    },
    {
      label: 'reponse_export', tooltip: 'Télécharger la demande en pdf', icon: 'picture_as_pdf',
      click: (row: ResponseForm) => this.downloadPdf(row),
      iconcolor: 'primary',
    },
    {
      label: 'reponse_zip', tooltip: 'Télécharger la demande en zip', icon: 'folder_zip',
      click: (row: ResponseForm) => this.downloadZip(row),
      hidden: (row: ResponseForm) => this._hiddenDonwloadZipAction(row),
      iconcolor: 'primary',
    },
  ];
  urlListValidate: string;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    public fileService: FileSaverService,
    private pubSubSvc: PubSubService,
    private sanitized: DomSanitizer,
    private snackSvc: SnackBarToastyService,
    private helperSvc: HelperService,
    private formulaireSvc: FormulaireService,
    private responseSvc: ResponsesService,
    public instructionSvc: InstructionService) {
  }

  ngOnInit(): void {
    this.dsResponses.daoService = this.responseSvc;
    this._getResponses();
    this.subSink.sink = this.responseSvc.onSendBlockAdministratif$.subscribe(_value => {
      if (_value) {
        this.dataTable.reload();
      }
    });
    this.instructionSvc.onInstructionChanged$.subscribe(_changed => {
      if (_changed) {
        this.dataTable.reload();
      }
    });
    this._updateBackfilter();
  }

  downloadZip(row: ResponseForm) {
    if (row) {
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.responseSvc.downloadDemande(row, 'zip')
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe();
    }
  }

  downloadPdf(row: ResponseForm) {
    if (row) {
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.responseSvc.downloadDemande(row)
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe();
    }
  }


  exportExcel() {
    this.exporting = true;
    this.extraParams.set('archived', String(this.onlyArchived));
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.responseSvc
      .exportExcel(this.form.uuid, this.extraParams, this.extraDict)
      .pipe(finalize(() => {
        this.exporting = false;
        this.pubSubSvc.publish('loading', false)
      }))
      .subscribe(_excel => {
        const slugify = new SlugifyPipe();
        const fileName = `EXPORT_DEMANDES_${slugify.transform(this.form.nom)}`;
        this.fileService.FileSave(_excel, fileName, 'xlsx');
      });
  }
  private _getValueField(_filter: FilterFieldCustomEnabled) {
    let _value = _filter.value;
    if (_filter.type === FieldType.TypeDate) {
      const dt: DatePipe = new DatePipe(this.locale);
      _value = dt.transform(_filter.value, 'yyyy-MM-dd');
    }
    if (_filter.type === FieldType.TypeSvcCmp) {
      const entite = _filter.value as Entite;
      _value = entite.entite;
    }
    return _value;
  }
  /**
   * Filtrage à envoyer des champs du formulaire
   * @param {FilterFieldCustomEnabled[]} filters
   */
  public filteringCustomsFields(filters: FilterFieldCustomEnabled[]) {
    const KEY = 'filters_responses';
    const SEPARATOR = '||';
    this.extraDict.delete(KEY);
    if (filters) {
      const values = [];
      filters.forEach((_filter: FilterFieldCustomEnabled) => {
        const _value = this._getValueField(_filter);
        const type = this.formulaireSvc.getFieldTypeToControlTypeEnum(_filter.type);
        const value = `${_value}${SEPARATOR}${type}${SEPARATOR}${_filter.operator}${SEPARATOR}${_filter.field}`;
        values.push(value);
      });
      this.extraDict.set(KEY, values);
    }
    setTimeout(() => this.dataTable.reload());
  }
  /**
   * Création des filtres pour les réponses
   * @param {FilterFieldResponseEnabled[]} filters
   */
  public filteringResponsesFields(filters: FilterFieldResponseEnabled[]) {
    const FIELD_OPERATOR = 'field_operator';
    this.extraDict.set(FIELD_OPERATOR, []);
    this.extraParams.clear();
    this.extraDict.clear();
    if (filters) {
      filters.forEach((_filter: FilterFieldResponseEnabled) => {
        switch (_filter.type) {
          case 'by_instructions__state':
            const values = (_filter.value as ResponseStateGestModel[]).map(v => v.state.toString());
            this.extraDict.set(_filter.type, values);
            break;
          case 'dt_created':
          case 'dt_updated':
            this._addFieldResponse(`${FIELD_OPERATOR}`, this._filterFieldDate(_filter.type, _filter.value), `${_filter.type}`);
            break;
        }
      });
    }
    setTimeout(() => this.dataTable.reload());
  }
  tabResponse(response: ResponseForm) {
    this.onSelectResponse.emit(response);
  }
  modaleResponse(response: ResponseForm) {
    this.responseSvc.openInModaleResponse(response);
  }
  demandeurInfo(demandeur: Individu) {
    return `${demandeur.first_name} ${demandeur.last_name}`;
  }

  getResponseForm(response: ResponseForm) {
    this.router.navigate(['response', response.uuid], {relativeTo: this.route.parent});
  }

  getStateForm(row: ResponseForm) {
    return this.responseSvc.stateLabel(row.state);
  }
  /**
   * Affichage de la dernière instruction de la demande
   * @param {ResponseForm} row
   * @param {FormModel} form
   */
  getStateInstructions(row: ResponseForm, form: FormModel) {
    let instructionLabel: SafeHtml = '';
    const currentInstruction = row.last_instruction_obj;
    const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
    if (currentInstruction) {
      const state = this.responseSvc.stateResponseInstructionModel(currentInstruction.state, FormType.Demande, form);
      if (state) {
        const stateDesign = `<mat-icon class="material-icons" style="vertical-align: middle; color: ${state.color};">${state.icon}</mat-icon><span style="color: ${state.color};">${state.label}</span>`;
        instructionLabel = sp.transform(stateDesign);
      }
    } else {
      instructionLabel = sp.transform(`<i>${this.responseSvc.stateLabelWaiting()}</i>`);
    }
    return instructionLabel;
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
  /**
   * L'url des réponses selon si le formulaire est injecté en Input ou en querystring (id)
   * @private
   */
  private _getResponses() {
    let param: string;
    if (this.form) {
      param = this.form.uuid;
    } else {
      param = this.route.snapshot.paramMap.get('id');
      this.subSink.sink = this.formulaireSvc.get(param).subscribe(_form => this.form = _form);
    }
    this.urlListValidate = this.responseSvc.getUrlReponses(param, this.onlyArchived);
  }
  /**
   * Recherche une valeur (qui contient, fieldName) dans un tableau de string, renvoie l'indice du tableau ou se trouve l'élément
   * @param {string} fieldName : par exemple dt_created
   * @param {string[]} values
   * @return {number} : indice ou se trouve fieldName dans values
   */
  private _isFieldExists(fieldName: string, values: string[]) {
    let found = -1;
    values.forEach((v, idx) => {
      const isFound = v.indexOf(fieldName);
      if (isFound !== -1) {
        found = idx;
        return;
      }
    });
    return found;
  }
  /**
   * Ajout operateur extraDict
   * @param {string} key : clé de filtrage, multi-valuée
   * @param {string} value : valeur de filtrage à ajouter
   * @param {string} fieldName : le champ à filtrer (dt_created, dt_updated, ...) dans key
   * @param removeFieldName
   */
  private _addFieldResponse(key: string, value: string, fieldName: string, removeFieldName = true) {
    let values = [];
    if (this.extraDict.has(key)) {
      values = this.extraDict.get(key); // [values]
      if (values && values.length > 0 && removeFieldName) {
        const isFound = this._isFieldExists(fieldName, values);
        if (isFound !== -1) { // on évite un critère sur le même champ, ie: dt_created||...&dt_created||...
          values.splice(isFound, 1);
        }
      }
    }
    values.push(value);
    this.extraDict.set(key, values);
  }
  /**
   * Formatte le filtre sur une date
   * @param field
   * @param value
   * @private
   */
  private _filterFieldDate(field, value): string {
    const SEPARATOR = '||';
    const operator = 'eq';
    const type = 'date';
    const dp: DatePipe = new DatePipe(this.locale);
    const dt_created = dp.transform(value, 'yyyy-MM-dd');
    return `${field}${SEPARATOR}${type}${SEPARATOR}${operator}${SEPARATOR}${dt_created}`;
  }
  private _dataModale(title, message) {
    const data = new DialogData();
    const nl: NewlinePipe = new NewlinePipe();
    const messageInstruction = nl.transform(message);
    data.title = title;
    data.message = messageInstruction;
    data.buttonTextTrue = 'Oui';
    data.buttonTextFalse = 'Non';

    return data;
  }
  private _openArchiveConfirmation(response: ResponseForm) {
    const data = this._dataModale(
      `Archiver cette demande "${this.responseSvc.stateInstructionLabel(response.last_instruction_obj?.state).toLowerCase()}" ?`,
      `Confirmez-vous l'archivage de la demande de ${response.user_obj.first_name} ${response.user_obj.last_name} ?\n
    Elle se retrouvera dans l'onglet "${this.ONGLET_ARCHIVED}"`);
    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pubSubSvc.publish('loading', true);
        response.state = ReponseState.archived;
        this.responseSvc.patch(response, 'uuid')
          .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
          .subscribe(_ => {
            this.snackSvc.toasty('Archivage',
            `La demande a bien été archivée, retrouvez la dans l\'onglet "${this.ONGLET_ARCHIVED}"`, typeToast.success);
            this.dataTable.reload();
        });
      }
    });
    dialogRef.updatePosition({top: '100px'});
  }
  private _openUnarchiveConfirmation(response: ResponseForm) {
    const data = this._dataModale(
      `Désarchiver cette demande "${this.responseSvc.stateInstructionLabel(response.last_instruction_obj?.state).toLowerCase()}" ?`,
      `Confirmez-vous le désarchivage de la demande de ${response.user_obj.first_name} ${response.user_obj.last_name} ?\n
              Elle se retrouvera dans la liste des demandes`);
    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pubSubSvc.publish('loading', true);
        response.state = ReponseState.published;
        this.responseSvc.patch(response, 'uuid')
          .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
          .subscribe(_ => {
            this.snackSvc.toasty('Désarchivage',
            `La demande a bien été désarchivée, retrouvez la dans la liste des demandes"`, typeToast.success);
            this.dataTable.reload();
        });
      }
    });
    dialogRef.updatePosition({top: '100px'});
  }
  private _hiddenArchiveAction(response: ResponseForm) {
    return !(response.state !== ReponseState.archived
      && [ResponseStateInstruction.accepted, ResponseStateInstruction.refused, ResponseStateInstruction.closed].includes(response?.last_instruction_obj?.state));
  }
  private _hiddenUnarchiveAction(response: ResponseForm) {
    return !(this.onlyArchived && response.state === ReponseState.archived
      && [ResponseStateInstruction.accepted, ResponseStateInstruction.refused, ResponseStateInstruction.closed].includes(response?.last_instruction_obj?.state));
  }
  private _updateBackfilter() {
    if (this.filterState !== null) {
      this.backFilterStates = [];
      switch (Number(this.filterState)) {
        case TypeDemandes.En_attente:
          this.backFilterStates.push(-1);
          break;
        case TypeDemandes.En_traitement:
          this.backFilterStates.push(ResponseStateInstruction.in_progress);
          break;
        case TypeDemandes.Traitees:
          this.backFilterStates.push(ResponseStateInstruction.accepted);
          this.backFilterStates.push(ResponseStateInstruction.refused);
          this.backFilterStates.push(ResponseStateInstruction.closed);
          break;
        case TypeDemandes.Archivees:
          // Traité dans ListHomeComponent
          this.backFilterStates = null;
          break;
        case TypeDemandes.Incomplet:
          this.backFilterStates.push(ResponseStateInstruction.incomplete);
          break;
      }
      this.filterState = null;
    } else {
      this.backFilterStates = null;
    }
  }

  private _hiddenDonwloadZipAction(row: ResponseForm) {
    return !row.has_files;
  }
}
